
import { cookieApi } from "./cookieApi";
import {
  setTokens,
  clearTokens,
  getRefreshToken,
  markSessionActive,
} from "./tokenManager";

export const authApi = {
  register: async (userData) => {
    const response = await cookieApi.post("/auth/users/", userData);
    return response.data;
  },

  login: async (phone, password) => {
    const response = await cookieApi.post("/auth/jwt/create/", {
      phone,
      password,
    });

    const { access, refresh } = response.data;

    if (!access || !refresh) {
      throw new Error("Login response did not contain both access and refresh tokens.");
    }

    setTokens(access, refresh);
    markSessionActive();

    return response.data;
  },

  logout: async () => {
    try {
      // Local logout. A server-side blacklist endpoint can be added
      // if the backend supports refresh-token invalidation.
    } finally {
      clearTokens();
    }
  },

  refresh: async () => {
    const refresh = getRefreshToken();

    if (!refresh) {
      clearTokens();
      throw new Error("No refresh token is available.");
    }

    const response = await cookieApi.post("/auth/jwt/refresh/", {
      refresh,
    });

    const { access, refresh: rotatedRefresh } = response.data;

    if (!access) {
      throw new Error("Refresh response did not contain an access token.");
    }

    setTokens(access, rotatedRefresh || refresh);

    return response.data;
  },

  requestOTP: async (phone) => {
    const response = await cookieApi.post(
      "/api/v1/auth/request-otp/",
      { phone },
    );
    return response.data;
  },

  verifyOTP: async (phone, code) => {
    const response = await cookieApi.post(
      "/api/v1/auth/verify-otp/",
      { phone, code },
    );

    const { access, refresh } = response.data;

    if (!access || !refresh) {
      throw new Error(
        "OTP verification response did not contain both access and refresh tokens.",
      );
    }

    setTokens(access, refresh);
    markSessionActive();

    return response.data;
  },

  resetPassword: async (phone) => {
    const response = await cookieApi.post(
      "/auth/users/reset_password/",
      { phone },
    );
    return response.data;
  },

  resetPasswordConfirm: async (uid, token, new_password) => {
    const response = await cookieApi.post(
      "/auth/users/reset_password_confirm/",
      {
        uid,
        token,
        new_password,
      },
    );
    return response.data;
  },

  getUser: async () => {
    const response = await cookieApi.get("/auth/users/me/");
    return response.data;
  },

  updateUser: async (userData) => {
    const response = await cookieApi.patch(
      "/auth/users/me/",
      userData,
    );
    return response.data;
  },
};
